var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"value":_vm.value,"items":_vm.severityLevels,"label":_vm.label,"multiple":_vm.multiple,"attach":_vm.attach,"chips":_vm.chips,"clearable":_vm.clearable},on:{"input":function($event){return _vm.updateValue($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }